import { Pagination, Tooltip } from "antd";
import Search from "antd/lib/input/Search";
import React, { useEffect, useState } from "react";
// import { useParams, useHistory } from "react-router-dom";
import { useAppState } from "src/contexts/AppContext";
import Icons from "../components/icons";
import Swal from "sweetalert2";
import ColumnGroup from "antd/lib/table/ColumnGroup";

const _ = require("lodash");
//aaaa
// console.log("");
const Home = () => {
  // const [ischeckedtheme] = useState(localStorage.getItem("eoffice-theme"));
  const { state } = useAppState();
  // let { id } = useParams();
  const [homelist, setHomelist] = useState(null);
  const [pageCurrenNum, setPageCurrenNum] = useState(1);
  const [perPage, setPerPage] = useState(12);
  const [pageLength, setPageLength] = useState(1);
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(12);
  // const history = useHistory();

  const clickedItems = async (item) => {
    // console.log(item);
    const it = JSON.parse(localStorage.getItem("mlist"));
    const a = [];
    if (it) {
      a.push(...it, item);
    } else {
      a.push(item);
    }
    const af = _.uniqBy(a, (e) => {
      if (e.id === item.id) {
        e["application_name"] = item.application_name;
        e["group_id"] = item.group_id;
        e["group_name"] = item.group_name;
        e["orderb"] = item.orderb;
        e["orderd"] = e.orderd !== undefined ? e.orderd + 1 : 1;
        e["ordern"] = item.ordern;
        e["software_description"] = item.software_description;
        e["software_name"] = item.software_name;
      }

      return e.id;
    });
    // console.log(state.applist);
    // const result = async ()=>{
    //   await
    // }
    localStorage.setItem(
      "mlist",
      JSON.stringify(af.sort((a, b) => (a.orderd < b.orderd ? 1 : -1))),
      () => {
        window.location.href = item.application_name;
        // window.open(item.application_name);
        if (
          state.sidemenuclicked === null &&
          search === "" &&
          !state.isexternal
        ) {
          refreshList();
        }
      }
    );
  };

  // const unb = (item) => {
  //   return _.uniqBy(item, (e) => {
  //     if (e.id === item.id)
  //       e["orderd"] = e.orderd !== undefined ? e.orderd + 1 : 1;
  //     return e.id;
  //   });
  // };
  const refreshList = () => {
    const it = JSON.parse(localStorage.getItem("mlist"));
    setHomelist(
      paginate(
        it
          ? differenceList(
              it,
              state.applist.sort((a, b) => (a.ordern > b.ordern ? 1 : -1))
            )
          : state.applist.sort((a, b) => (a.ordern > b.ordern ? 1 : -1)),
        pageSize,
        1
      )
    );
    setPageLength(state.applist.length);
    setPageCurrenNum(1);
  };

  useEffect(() => {
    if (state.sidemenuclicked !== null) {
      const a = state.applist
        .filter((i, idx) => {
          return i.group_id === state.sidemenuclicked?.group_id;
        })
        .sort((a, b) => (a.ordern > b.ordern ? 1 : -1));
      setHomelist(a);
      setPageLength(a.length);
    }
  }, [state.sidemenuclicked]);

  function paginate(array, page_size, page_number) {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  }

  function differenceList(array1, array2) {
    const array3 = array2.filter(
      ({ id: id1 }) => !array1.some(({ id: id2 }) => id2 === id1)
    );
    const array4 = array2
      .map((e) => {
        array1.map((i) => {
          if (e.id === i.id) {
            e["orderb"] = i.orderb;
            e["ordern"] = i.ordern;
            e["orderd"] = i.orderd;
          }
        });
        return e;
      })
      .sort((a, b) => (a.orderd < b.orderd ? 1 : -1));
    return [...array4];
  }

  useEffect(() => {
    const it = JSON.parse(localStorage.getItem("mlist"));
    if (state.sidemenuclicked === null && search === "") {
      setHomelist(
        paginate(
          it
            ? differenceList(
                it,
                state.applist.sort((a, b) => (a.ordern > b.ordern ? 1 : -1))
              )
            : state.applist.sort((a, b) => (a.ordern > b.ordern ? 1 : -1)),
          pageSize,
          pageCurrenNum
        )
      );
      setPageLength(state.applist.length);
    }
  }, [state.applist, pageCurrenNum, pageSize]);

  useEffect(() => {
    const it = JSON.parse(localStorage.getItem("mlist"));
    setPageCurrenNum(1);
    if (search) {
      const a = state.applist
        .filter(
          (i) =>
            i.software_name.toLowerCase().includes(search.toLowerCase()) ||
            i.group_name.toLowerCase().includes(search.toLowerCase()) ||
            i.software_description.toLowerCase().includes(search.toLowerCase())
        )
        .sort((a, b) => (a.ordern > b.ordern ? 1 : -1));
      setPageLength(1);
      setHomelist(a);
      // console.log(a);
    } else if (search === "") {
      setHomelist(
        paginate(
          it
            ? differenceList(
                it,
                state.applist.sort((a, b) => (a.ordern > b.ordern ? 1 : -1))
              )
            : state.applist.sort((a, b) => (a.ordern > b.ordern ? 1 : -1)),
          pageSize,
          pageCurrenNum
        )
      );
      setPageLength(state.applist.length);
    }
  }, [search]);

  return (
    <div>
      <div className="main-content-body">
        <div className="text-right mb-3">
          <Search
            style={{ width: "250px" }}
            placeholder="Хайх утгаа оруулна уу"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>

        <div className="row row-sm">
          {homelist !== null ? (
            homelist?.map((i, idx) => {
              return (
                <div key={idx} className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <div
                    className="card overflow-hidden project-card"
                    style={{ minHeight: "160px" }}
                  >
                    <a
                      rel="noreferrer"
                      href={i.application_name}
                      onClick={() => clickedItems(i)}
                    >
                      <div className="card-body">
                        <div className="d-flex">
                          <div className="my-auto">
                            <Icons {...i} />
                          </div>
                          <div className="project-content">
                            <h5>{i.software_name}</h5>
                          </div>
                        </div>
                        <div
                          className="project-content"
                          style={{
                            paddingTop: 10,
                            minHeight: 70,
                            lineHeight: 10,
                          }}
                        >
                          <ul>
                            <li
                              style={{
                                textJustify: "center",
                              }}
                            >
                              {i.software_description.length > 138
                                ? i.substring(0, 137) + " . . . "
                                : i.software_description}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </a>
                    {i.orderd ? (
                      <Tooltip title="Таны хандсан">
                        <div
                          style={{
                            position: "absolute",
                            bottom: 3,
                            right: 3,
                          }}
                          onClick={() => {
                            Swal.fire({
                              title: "Хандсан жагсаалтаас хасах уу?",
                              showCancelButton: true,
                              confirmButtonText: "Тийм",
                              cancelButtonText: "Үгүй",
                              // denyButtonText: "Үгүй",
                            }).then((result) => {
                              /* Read more about isConfirmed, isDenied below */
                              if (result.isConfirmed) {
                                const it = JSON.parse(
                                  localStorage.getItem("mlist")
                                );
                                localStorage.setItem(
                                  "mlist",
                                  JSON.stringify(
                                    it.filter((e) => e.id !== i.id)
                                  )
                                );
                                refreshList();

                                Swal.fire("устгагдлаа!", "", "success");
                              } else if (result.isDenied) {
                                Swal.fire("Цуцлагдлаа", "", "info");
                              }
                            });
                          }}
                        >
                          <Icons iname={"fav2"} />
                        </div>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div
              className="card overflow-hidden project-card"
              style={{ backgroundColor: "red" }}
            >
              Өгөгдөл алга байна
            </div>
          )}
        </div>
      </div>
      {pageLength > 1 && (
        <div className="m-2 text-right">
          <Pagination
            defaultCurrent={1}
            total={pageLength}
            current={pageCurrenNum}
            defaultPageSize={perPage}
            pageSizeOptions={[10, 12, 20, 50, 100]}
            // onShowSizeChange={(e) => {
            //   console.log(e);
            // }}
            onChange={(page, psize) => {
              // console.log("==>", page, psize);
              setPageSize(psize);
              setPageCurrenNum(page);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default React.memo(Home);
